import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import SchoolIcon from '@mui/icons-material/School';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import FlagIcon from '@mui/icons-material/Flag';

const ActualiteFormationRGEBPage = () => {
  // Photos disponibles
  const photoDTAllocution = '/assets/rgeb/DUN1.png';
  const photoDTSuivi = '/assets/rgeb/DUN2.png';
  const photoCandidats1 = '/assets/rgeb/DUN3.png';
  const photoCandidats2 = '/assets/rgeb/DUN4.png';
  const photoCandidats3 = '/assets/rgeb/IMG_0636.JPG';
  const photoCandidats4 = '/assets/rgeb/IMG_0639.JPG';

  // Photo de couverture (hero) : le DT lors de son allocution
  const photoHero = photoDTAllocution;

  // Objectifs spécifiques du RGEB
  const objectifs = [
    'Déterminer l’effectif des entreprises en activité dans l’économie et leur répartition à travers le territoire national.',
    'Actualiser les données économiques sur les entreprises formelles en vue de la mise à jour du répertoire des entreprises.',
    'Disponibiliser les données économiques sur les entreprises informelles.',
    'Faciliter l’exécution des futures enquêtes sur les entreprises en rendant disponible une base de sondage exhaustive.',
    'Identifier les caractéristiques socio-démographiques des chefs d’entreprises.',
    'Évaluer la place de la femme dans l’entrepreneuriat au Burundi.',
    'Évaluer le niveau des emplois créés par les entreprises au Burundi.',
    'Disposer d’informations sur l’opinion des dirigeants d’entreprises en ce qui concerne le climat des affaires au Burundi.',
    'Identifier les difficultés rencontrées par les promoteurs d’entreprises dans l’exercice de leurs activités.',
    'Mesurer les investissements nationaux et étrangers du secteur privé au Burundi.',
  ];

  // Résultats attendus du RGEB
  const resultatsAttendus = [
    'La répartition spatiale des unités économiques installées sur le territoire national est connue.',
    'Une base de données actualisée sur les entreprises formelles et informelles du pays est disponible.',
    'Une base de sondage actualisée et exhaustive est disponible pour faciliter l’exécution des futures enquêtes sur les entreprises.',
    'Les caractéristiques socio-démographiques des chefs d’entreprises sont connues.',
    'La place de la femme dans l’entrepreneuriat au Burundi est évaluée.',
    'Les investissements nationaux et étrangers du secteur privé au Burundi sont connus.',
    'Les emplois générés par les entreprises au Burundi sont évalués.',
    'L’opinion des chefs d’entreprises sur le climat des affaires au Burundi est connue.',
    'Les difficultés rencontrées par les promoteurs d’entreprises dans l’exercice de leurs activités sont identifiées.',
  ];

  return (
    <div style={styles.container}>
      <NavigationBar />

      <main style={styles.main}>
        <header style={styles.header}>
          {/* BADGES */}
          <div style={styles.badges}>
            <span style={styles.badgeRed}>INSBU</span>
            <span style={styles.badgeGreen}>RGEB 2026</span>
            <span style={styles.badgeGray}>Actualité</span>
          </div>

          {/* TITRE ACCROCHEUR */}
          <h1 style={styles.title}>
            Lancement de la formation sur les outils de collecte de données du Recensement Général des Entreprises au Burundi 2026
          </h1>

          {/* MÉTADONNÉES */}
          <div style={styles.meta}>
            <span style={styles.metaItem}>
              <CalendarTodayIcon style={styles.metaIcon} /> À partir du 07 octobre 2026
            </span>
            <span style={styles.metaItem}>
              <LocationOnIcon style={styles.metaIcon} /> Hôtel La Détente, Bujumbura
            </span>
            <span style={styles.metaItem}>
              <AccessTimeIcon style={styles.metaIcon} /> Lecture 5 min
            </span>
          </div>

          {/* PHOTO DE COUVERTURE */}
          <div style={styles.imageWrapper}>
            <img
              src={photoHero}
              alt="Le Directeur Technique de l'INSBU lors de son allocution"
              style={styles.heroImage}
              onError={(e) => {
                e.target.src = 'https://placehold.co/820x420/008D36/FFFFFF?text=Formation+RGEB+2026';
              }}
            />
            <p style={styles.imageCaption}>
              Le Directeur Technique de l’INSBU, M. Dunia Prudence, s’adressant aux agents recenseurs lors de la cérémonie d’ouverture.
            </p>
          </div>

          {/* CHAPEAU - RÉSUMÉ EN 5W */}
          <p style={styles.chapeau}>
            <strong>Bujumbura, 7 octobre 2026</strong> — L’<strong>Institut National de la Statistique du Burundi (INSBU)</strong> a lancé ce mercredi la formation sur les <strong>outils de collecte de données du Recensement Général des Entreprises au Burundi de 2026 (RGEB, 2026)</strong>. D’une durée de <strong>sept jours</strong>, la session se tient à l’<strong>Hôtel La Détente, à Bujumbura</strong>, et mobilise <strong>plus de 350 agents recenseurs</strong> qui seront déployés sur l’ensemble du territoire national.
          </p>
        </header>

        {/* CORPS DE L'ARTICLE */}
        <article style={styles.article}>

          {/* SECTION 1 : MESSAGE DU DIRECTEUR TECHNIQUE */}
          <h2 style={styles.h2}>
            <TrendingUpIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            Ordre, transparence et honnêteté : le message du Directeur Technique
          </h2>
          <p style={styles.p}>
            Dans un message adressé aux agents recenseurs, <strong>Monsieur Dunia Prudence, Directeur Technique à l’INSBU</strong>, a insisté sur les valeurs qui doivent caractériser chaque agent durant cette formation et sur le terrain : <strong>l’ordre, la transparence et l’honnêteté</strong>.
          </p>
          <p style={styles.p}>
            Il a profité de cette occasion pour <strong>conseiller aux agents recenseurs de s’abstenir de toute tricherie</strong> en ce qui concerne l’identité individuelle et la qualification académique. Un rappel ferme qui témoigne de l’exigence de rigueur et de fiabilité qui entoure cette opération d’envergure nationale.
          </p>
          <p style={styles.p}>
            Ce recensement sera réalisé par <strong>plus de 350 agents recenseurs</strong>, répartis sur l’ensemble du territoire, dans le but de dresser un portrait fidèle et exhaustif du tissu économique burundais.
          </p>

          {/* ENCADRÉ CITATION */}
          <div style={styles.quoteBlock}>
            <ChatBubbleOutlineIcon style={{ fontSize: '2.5rem', color: '#008D36', marginBottom: '10px' }} />
            <blockquote style={styles.quoteText}>
              « L’ordre, la transparence et l’honnêteté doivent caractériser les agents recenseurs durant la formation. Abstenez-vous de toute tricherie en ce qui concerne l’identité individuelle et la qualification académique. »
            </blockquote>
            <p style={styles.quoteAuthor}>— M. Dunia Prudence, Directeur Technique de l’INSBU</p>
          </div>

          {/* SECTION 2 : OBJECTIFS DU RGEB */}
          <h2 style={styles.h2}>
            <GpsFixedIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            Les objectifs du Recensement Général des Entreprises
          </h2>
          <p style={styles.p}>
            Globalement, le recensement vise à collecter des informations quantitatives et qualitatives sur <strong>toutes les entreprises (formelles et informelles) installées sur le territoire national</strong>, tout en mettant à profit les technologies de l’information et de la communication. Spécifiquement, les objectifs poursuivis sont les suivants :
          </p>
          <div style={styles.objectifsGrid}>
            {objectifs.map((objectif, index) => (
              <div key={index} style={styles.objectifCard}>
                <span style={styles.objectifNumber}>{String(index + 1).padStart(2, '0')}</span>
                <p style={styles.objectifText}>{objectif}</p>
              </div>
            ))}
          </div>

          {/* SECTION 3 : RÉSULTATS ATTENDUS */}
          <h2 style={styles.h2}>
            <FlagIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
            Les résultats attendus
          </h2>
          <p style={styles.p}>
            À la fin du processus, les résultats suivants seront atteints :
          </p>
          <div style={styles.practicalBlock}>
            {resultatsAttendus.map((resultat, index) => (
              <div key={index} style={styles.practicalItem}>
                <CheckCircleIcon style={{ color: '#008D36', marginRight: '10px', flexShrink: 0 }} />
                <div>
                  <p style={styles.practicalText}>{resultat}</p>
                </div>
              </div>
            ))}
          </div>

          {/* SECTION 4 : GALERIE PHOTOS */}
          <div style={styles.gallery}>
            <h2 style={styles.h2Gallery}>
              <PhotoCameraIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
              Galerie : Les temps forts de la formation
            </h2>
            <div style={styles.galleryGrid}>
              <div style={styles.galleryItem}>
                <img
                  src={photoDTAllocution}
                  alt="Le Directeur Technique lors de son allocution"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=DT+Allocution'}
                />
                <p style={styles.galleryCaption}>M. Dunia Prudence, Directeur Technique de l’INSBU, lors de son allocution.</p>
              </div>
              <div style={styles.galleryItem}>
                <img
                  src={photoDTSuivi}
                  alt="Le Directeur Technique suivant les agents recenseurs"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=DT+Suivi'}
                />
                <p style={styles.galleryCaption}>Le Directeur Technique attentif au déroulement de la formation.</p>
              </div>
              <div style={styles.galleryItem}>
                <img
                  src={photoCandidats1}
                  alt="Candidats agents recenseurs à l'écoute"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Candidats+1'}
                />
                <p style={styles.galleryCaption}>Les candidats agents recenseurs lors de l’écoute de l’allocution du Directeur Technique.</p>
              </div>
              <div style={styles.galleryItem}>
                <img
                  src={photoCandidats2}
                  alt="Candidats agents recenseurs en salle"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Candidats+2'}
                />
                <p style={styles.galleryCaption}>Vue de la salle de formation : les candidats agents recenseurs attentifs.</p>
              </div>
              <div style={styles.galleryItem}>
                <img
                  src={photoCandidats3}
                  alt="Candidats agents recenseurs lors de la formation"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Candidats+3'}
                />
                <p style={styles.galleryCaption}>Les participants suivant les échanges de la première journée de formation.</p>
              </div>
              <div style={styles.galleryItem}>
                <img
                  src={photoCandidats4}
                  alt="Candidats agents recenseurs concentrés"
                  style={styles.galleryImg}
                  onError={(e) => e.target.src = 'https://placehold.co/300x200/008D36/FFFFFF?text=Candidats+4'}
                />
                <p style={styles.galleryCaption}>Les agents recenseurs en pleine prise de notes durant la session.</p>
              </div>
            </div>
          </div>

          {/* CONCLUSION */}
          <div style={styles.conclusion}>
            <h2 style={styles.h2}>
              <PeopleIcon style={{ fontSize: '1.8rem', marginRight: '10px', verticalAlign: 'middle', color: '#008D36' }} />
              Vers une photographie complète du tissu économique burundais
            </h2>
            <p style={styles.p}>
              À travers cette formation de sept jours, l’INSBU outille plus de <strong>350 agents recenseurs</strong> sur les outils de collecte de données du RGEB 2026. Cette opération d’envergure nationale est essentielle pour <strong>actualiser le répertoire des entreprises</strong>, fournir une base de sondage exhaustive aux futures enquêtes et éclairer les politiques économiques du Burundi.
            </p>
            <p style={styles.p}>
              Les données collectées permettront notamment d’<strong>évaluer la place de la femme dans l’entrepreneuriat</strong>, de mesurer les investissements nationaux et étrangers, et d’identifier les difficultés rencontrées par les promoteurs d’entreprises — autant d’informations précieuses pour améliorer le climat des affaires et soutenir la croissance inclusive.
            </p>
            <div style={styles.vive}>
              <p><strong>Vive le RGEB 2026 !</strong></p>
              <p><strong>Vive un système statistique national au service du développement !</strong></p>
            </div>
          </div>

        </article>
      </main>

      <Footer />
    </div>
  );
};

// ================= STYLES =================
const styles = {
  container: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    flex: 1,
    maxWidth: '820px',
    margin: '0 auto',
    padding: '40px 20px',
    width: '100%',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    paddingBottom: '30px',
    borderBottom: '2px solid #e0e0e0',
  },
  badges: {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  badgeRed: {
    backgroundColor: '#E30613',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGreen: {
    backgroundColor: '#008D36',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  badgeGray: {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '0.75rem',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  title: {
    color: '#1a1a1a',
    fontSize: '2.4rem',
    fontWeight: '700',
    lineHeight: 1.2,
    marginBottom: '12px',
    letterSpacing: '-0.3px',
  },
  meta: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '20px',
    marginBottom: '20px',
    fontSize: '0.9rem',
    color: '#6c757d',
  },
  metaItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
  },
  metaIcon: {
    fontSize: '1rem',
    color: '#008D36',
  },
  imageWrapper: {
    marginBottom: '24px',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  heroImage: {
    width: '100%',
    height: 'auto',
    maxHeight: '420px',
    objectFit: 'cover',
    display: 'block',
    borderRadius: '8px 8px 0 0',
  },
  imageCaption: {
    fontSize: '0.85rem',
    color: '#6c757d',
    textAlign: 'center',
    padding: '8px 0 4px 0',
    fontStyle: 'italic',
    backgroundColor: '#fafafa',
    margin: 0,
    borderBottom: '1px solid #eaeaea',
    borderRadius: '0 0 8px 8px',
  },
  chapeau: {
    fontSize: '1.2rem',
    lineHeight: 1.7,
    color: '#2c3e50',
    maxWidth: '700px',
    margin: '0 auto',
    fontWeight: '400',
    borderLeft: '4px solid #008D36',
    paddingLeft: '20px',
    textAlign: 'left',
  },
  article: {
    backgroundColor: 'white',
    padding: '40px 45px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
    marginBottom: '40px',
  },
  h2: {
    color: '#008D36',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginTop: '40px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
    display: 'flex',
    alignItems: 'center',
  },
  h2Gallery: {
    color: '#008D36',
    fontSize: '1.5rem',
    fontWeight: '600',
    marginTop: '20px',
    marginBottom: '16px',
    paddingBottom: '6px',
    borderBottom: '2px solid #eaeaea',
    display: 'flex',
    alignItems: 'center',
  },
  p: {
    fontSize: '1.05rem',
    lineHeight: 1.8,
    color: '#1e1e1e',
    marginBottom: '20px',
    textAlign: 'justify',
  },
  // BLOC CITATION
  quoteBlock: {
    backgroundColor: '#f0f7f2',
    padding: '25px 30px',
    borderRadius: '12px',
    margin: '30px 0',
    textAlign: 'center',
    border: '1px solid #d0e6d6',
  },
  quoteText: {
    fontSize: '1.4rem',
    lineHeight: 1.6,
    color: '#1a3b2e',
    fontWeight: '400',
    fontStyle: 'italic',
    margin: '0 0 10px 0',
  },
  quoteAuthor: {
    fontSize: '1rem',
    color: '#555',
    margin: 0,
    fontWeight: '600',
  },
  // ===== GRILLE DES OBJECTIFS =====
  objectifsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
    gap: '15px',
    marginBottom: '10px',
  },
  objectifCard: {
    position: 'relative',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    borderRadius: '10px',
    padding: '20px 18px 16px 18px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  },
  objectifNumber: {
    position: 'absolute',
    top: '-10px',
    left: '18px',
    backgroundColor: '#008D36',
    color: 'white',
    fontSize: '0.75rem',
    fontWeight: '700',
    padding: '3px 10px',
    borderRadius: '20px',
    letterSpacing: '0.5px',
  },
  objectifText: {
    fontSize: '0.92rem',
    lineHeight: 1.6,
    color: '#333',
    margin: '8px 0 0 0',
    textAlign: 'justify',
  },
  // ===== BLOC RÉSULTATS ATTENDUS =====
  practicalBlock: {
    backgroundColor: '#f0f7f2',
    border: '1px solid #d0e6d6',
    borderRadius: '10px',
    padding: '20px 22px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
  },
  practicalItem: {
    display: 'flex',
    alignItems: 'flex-start',
    fontSize: '0.95rem',
    color: '#1e1e1e',
    lineHeight: 1.5,
  },
  practicalText: {
    fontSize: '0.95rem',
    color: '#333',
    margin: 0,
    lineHeight: 1.55,
    textAlign: 'justify',
  },
  // GALERIE PHOTOS
  gallery: {
    marginTop: '30px',
  },
  galleryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: '15px',
  },
  galleryItem: {
    backgroundColor: '#fafafa',
    borderRadius: '8px',
    overflow: 'hidden',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
  },
  galleryImg: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    display: 'block',
  },
  galleryCaption: {
    fontSize: '0.8rem',
    color: '#555',
    padding: '6px 10px',
    textAlign: 'center',
    fontStyle: 'italic',
    margin: 0,
    borderTop: '1px solid #eaeaea',
    backgroundColor: '#ffffff',
  },
  conclusion: {
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: '2px solid #eaeaea',
  },
  vive: {
    marginTop: '20px',
    textAlign: 'center',
    fontSize: '1.1rem',
    lineHeight: 2,
    color: '#008D36',
    fontWeight: '600',
  },
};

export default ActualiteFormationRGEBPage;